module.exports = __webpack_public_path__ + "static/media/image_58.5435ca4d.png";